// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e806f5fc","453":"3789aab4","455":"47f1801e"}[chunkId] + ".chunk.js";
};